import React, { memo, useMemo } from 'react'
import dynamic from 'next/dynamic'

const customSubmitTypes = {
	paypalButton: dynamic(() => import('root/src/client/web/base/CustomButton/PayPalButton')),
	paypalSubscriptionButton: dynamic(() => import('root/src/client/web/base/CustomButton/PayPalSubscriptionButton')),
}

export const SubmitsUnstyled = memo(({
	customSubmitType, customSubmitsData, customPayPalAction, promotionAction, submitIndex,
}) => {
	const CustomSubmitComponent = useMemo(() => customSubmitTypes[customSubmitType],
		[customSubmitTypes, customSubmitType])

	if (!CustomSubmitComponent) {
		return null
	}

	return (
		<CustomSubmitComponent
			key={`${submitIndex}-custom`}
			customSubmitsData={customSubmitsData}
			submitIndex={submitIndex}
			customPayPalAction={customPayPalAction}
			promotionAction={promotionAction}
		/>
	)
})

export default SubmitsUnstyled
